import React from 'react';
import { IconButton as ChakraIconBtn, IconButtonProps } from '@chakra-ui/react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';

import {
  DownloadIcon,
  EditIcon,
  HideIcon,
  ShowIcon,
  TimesSquareIcon,
  UndoIcon,
} from '../../../../../../components/icons';

export enum IconType {
  delete = 'delete',
  undo = 'undo',
  download = 'download',
  change_password = 'change_password',
  show = 'show',
  hide = 'hide',
}

const IconMap: Record<IconType, any> = {
  delete: TimesSquareIcon,
  undo: UndoIcon,
  download: DownloadIcon,
  change_password: EditIcon,
  hide: HideIcon,
  show: ShowIcon,
};

const iconColor: Record<IconType, string> = {
  undo: 'limegreen',
  change_password: 'skyblue',
  download: 'blue',
  delete: 'crimson',
  hide: 'blue',
  show: 'blue',
};

interface Props extends Omit<IconButtonProps, 'type'> {
  onClick: () => void;
  type: IconType;

  title?: string;
  className?: string;
  style?: React.CSSProperties;
  color?: string;
}

export const IconButton: React.FC<Props> = ({
  onClick,
  title,
  type,
  className,
  style,
  color,
  ...rest
}) => {
  const Icon = IconMap[type];

  if (title) {
    return (
      <Tippy arrow={true} theme="light" animation="scale" content={title}>
        <ChakraIconBtn
          minW={8}
          border={0}
          p={0}
          w={8}
          h={8}
          flexShrink={0}
          className={`only-icon delete-btn ${className}`}
          colorScheme={color || iconColor[type]}
          style={style}
          onClick={onClick}
          icon={<Icon className={'icon-btn'} boxSize="16px" m={0} />}
          variant="solid"
          {...rest}
          aria-label={type}
        />
      </Tippy>
    );
  }
  return (
    <ChakraIconBtn
      minW={6}
      aria-label={type}
      p={0}
      w={8}
      h={8}
      flexShrink={0}
      className={`only-icon delete-btn ${className}`}
      colorScheme={color || iconColor[type]}
      style={style}
      onClick={onClick}
      icon={<Icon className={'icon-btn'} boxSize="16px" m={0} />}
      variant="solid"
    />
  );
};
